export const NAVIGATOR_MAIN_LABEL = "Menu principal";
export const NAVIGATOR_SECONDARY_LABEL = "Menu secundário";
export const NAVIGATOR_LOGO_LABEL = "Hub de Obras";
export const NAVIGATOR_EXPAND_LABEL = "Expandir menu";
export const NAVIGATOR_COLLAPSE_LABEL = "Recolher menu";
export const NAVIGATOR_OPEN_DRAWER_LABEL = "Abrir menu";
export const NAVIGATOR_CLOSE_DRAWER_LABEL = "Fechar menu";
export const NAVIGATOR_DRAWER_LABEL = "Menu de navegação";
